<template>
  <div>
    <Navbar></Navbar>

    <div class="container mt-3 mt-lg-5">

      <!-- TITLE-->
      <section class="section-profile-banner"></section>
      <div class="profile-container align-items-center">
        <img v-if="user.data.photoURL" :src="user.data.photoURL" class="img-fluid profile-picture" width="100px"
             :alt="user.data.displayName + ' profile picture'">
        <img v-else :src="'https://ui-avatars.com/api/?name=' + user.data.displayName + '&background=random&size=100'"
             class="img-fluid profile-picture" width="100px" alt="Default profile picture">

        <div class="text-start">
          <h1 v-if="user.data.displayName" class="typography-headline-lg fw-500">
            {{ user.data.displayName || 'Loading...' }}</h1>
          <p class="subtitle-1 text-muted mb-0">{{ user.data.email || 'Loading...' }}</p>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
              <button class="nav-link ripple ripple-primary active" id="nav-home-tab" data-bs-toggle="tab"
                      data-bs-target="#nav-home"
                      type="button" role="tab" aria-controls="nav-home" aria-selected="true">Home
              </button>
              <button class="nav-link ripple ripple-primary" id="nav-profile-tab" data-bs-toggle="tab"
                      data-bs-target="#nav-profile"
                      type="button" role="tab" aria-controls="nav-profile" aria-selected="false">Profile
              </button>
              <button class="nav-link ripple ripple-primary" id="nav-support-tab" data-bs-toggle="tab"
                      data-bs-target="#nav-support"
                      type="button" role="tab" aria-controls="nav-support" aria-selected="false">Support
              </button>
            </div>
          </nav>
          <div class="tab-content" id="nav-tabContent">

            <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
              <!-- SHORTCUTS -->
              <div class="row mt-4 mb-3">
                <div class="col-md-12 mb-2">
                  <p class="overline text-muted mb-1">Collections</p>
                </div>
                <div class="col-md-4 mb-3">
                  <router-link to="/user/gradients">
                    <div
                        class="card card-outline bg-primary-gradient translate-up ripple ripple-primary border-radius-25">
                      <div class="card-header bg-primary-gradient mt-2">
                        <i class="material-icons icon-wrap mdc-38">format_color_fill</i>
                      </div>
                      <div class="card-body">
                        <h2 class="typography-headline-sm fw-500 text-body-inverse">My gradients</h2>
                        <p class="subtitle-1 text-body-inverse mb-2">Take a look to your color creations</p>
                      </div>
                    </div>
                  </router-link>
                </div>
                <div class="col-6 col-md-4 mb-3">
                  <router-link to="/user/likes/gradients">
                    <div
                        class="card card-outline bg-secondary-gradient translate-up ripple ripple-primary border-radius-25">
                      <div class="card-header bg-secondary-gradient mt-2">
                        <i class="material-icons icon-wrap icon-wrap-red mdc-38">favorite</i>
                      </div>
                      <div class="card-body">
                        <h2 class="typography-headline-sm fw-500 text-dark">Liked gradients</h2>
                        <p class="subtitle-1 text-dark mb-2">See your gradients likes</p>
                      </div>
                    </div>
                  </router-link>
                </div>
                <div class="col-6 col-md-4 mb-3">
                  <router-link to="/user/likes/palettes">
                    <div
                        class="card card-outline bg-secondary-gradient translate-up ripple ripple-primary border-radius-25">
                      <div class="card-header bg-secondary-gradient mt-2">
                        <i class="material-icons icon-wrap icon-wrap-red mdc-38">favorite</i>
                      </div>
                      <div class="card-body">
                        <h2 class="typography-headline-sm fw-500 text-dark">Liked palettes</h2>
                        <p class="subtitle-1 text-dark mb-2">See your palettes likes</p>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>

            <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
              <!-- TABLE INFORMATION -->
              <div class="row mt-4 mb-3">
                <div class="col-md-12 mb-2">
                  <p class="overline text-muted mb-1">My information</p>
                </div>
                <div class="col-md-12 mb-3">
                  <div class="card card-outline">
                    <div class="card-body">
                      <div class="table-responsive">
                        <table class="table table-hover table-borderless mb-0">
                          <tbody>
                          <tr>
                            <th scope="row">Name</th>
                            <td v-if="user.data.displayName">{{ user.data.displayName || 'Loading...' }}</td>
                          </tr>
                          <tr>
                            <th scope="row">Email</th>
                            <td v-if="user.data.email">{{ user.data.email || 'Loading...' }}</td>
                          </tr>
                          <tr>
                            <th scope="row">UID</th>
                            <td v-if="user.data.uid">{{ user.data.uid || 'Loading...' }}</td>
                          </tr>
                          <tr>
                            <th scope="row">Provider</th>
                            <td v-if="getProvider() === 'google.com'">
                              <svg width="24" height="24" class="me-2">
                                <g fill="none" fill-rule="evenodd">
                                  <path
                                      d="M20.66 12.7c0-.61-.05-1.19-.15-1.74H12.5v3.28h4.58a3.91 3.91 0 0 1-1.7 2.57v2.13h2.74a8.27 8.27 0 0 0 2.54-6.24z"
                                      fill="#4285F4"></path>
                                  <path
                                      d="M12.5 21a8.1 8.1 0 0 0 5.63-2.06l-2.75-2.13a5.1 5.1 0 0 1-2.88.8 5.06 5.06 0 0 1-4.76-3.5H4.9v2.2A8.5 8.5 0 0 0 12.5 21z"
                                      fill="#34A853"></path>
                                  <path
                                      d="M7.74 14.12a5.11 5.11 0 0 1 0-3.23v-2.2H4.9A8.49 8.49 0 0 0 4 12.5c0 1.37.33 2.67.9 3.82l2.84-2.2z"
                                      fill="#FBBC05"></path>
                                  <path
                                      d="M12.5 7.38a4.6 4.6 0 0 1 3.25 1.27l2.44-2.44A8.17 8.17 0 0 0 12.5 4a8.5 8.5 0 0 0-7.6 4.68l2.84 2.2a5.06 5.06 0 0 1 4.76-3.5z"
                                      fill="#EA4335"></path>
                                </g>
                              </svg>
                              <span>Google</span>
                            </td>
                            <td v-if="getProvider() === 'twitter.com'">
                              <img src="@/assets/img/icons/twitter-fill.svg" class="img-fluid mdc-18 me-2"
                                   alt="Twitter icon" width="24" height="24">
                              <span>Twitter</span>
                            </td>
                            <td v-if="getProvider() === 'github.com'">
                              <img src="@/assets/img/icons/github-fill.svg" class="img-fluid mdc-18 me-2"
                                   alt="Github icon" width="24" height="24">
                              <span>GitHub</span>
                            </td>
                            <td v-if="getProvider() === 'password'">
                              <img src="@/assets/img/icons/mail-fill.svg" class="img-fluid mdc-18 me-2"
                                   alt="Email icon" width="24" height="24">
                              <span>Email and Password</span>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr>
              <!-- DELETE ACCOUNT -->
              <div class="row mb-3">
                <div class="col-md-12 mb-2">
                  <p class="overline text-danger mb-1">DANGER ZONE</p>
                </div>
                <div class="col-md-12 mb-3">
                  <div class="card card-outline border-danger">
                    <div class="card-header mt-2">
                      <h6 class="fw-500">Delete account</h6>
                    </div>
                    <div class="card-body">
                      <h6 class="subtitle-1 text-muted mb-3">Your account will be delete and you will lose your data.
                        Once you
                        delete your user, there is no going back. 😢</h6>
                      <button type="button" class="btn btn-danger ripple px-3" data-bs-toggle="modal"
                              data-bs-target="#deleteAccountModal">
                        <i class="material-icons-outlined me-2">delete</i>
                        Delete my account
                      </button>
                    </div>
                  </div>
                  <!-- DELETE ACCOUNT MODAL -->
                  <div class="modal fade" id="deleteAccountModal" tabindex="-1"
                       aria-labelledby="deleteAccountModalLabel"
                       aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered">
                      <div class="modal-content">
                        <div class="modal-header">
                          <p class="modal-title typography-headline-sm" id="deleteAccountModalLabel">Are you sure you
                            want to delete
                            your
                            account?</p>
                          <button type="button" class="btn-close img-logo" data-bs-dismiss="modal"
                                  aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                          <p class="subtitle-1 text-muted mb-3">Your account and your data will be delete and we'll
                            miss you
                            {{ this.user.data.displayName }} 😢</p>
                          <p class="subtitle-1 text-danger">This action cannot be undone!</p>
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-link ripple ripple-primary" data-bs-dismiss="modal">
                            Close
                          </button>
                          <button type="button" class="btn btn-danger ripple" data-bs-dismiss="modal"
                                  @click="onDeleteAccount">
                            Yes, Delete my account
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="tab-pane fade" id="nav-support" role="tabpanel" aria-labelledby="nav-support-tab">
              <!-- SUPPORT -->
              <div class="row mt-4 mb-3">
                <div class="col-md-12 mb-3">
                  <p class="overline text-muted mb-2">Support</p>
                  <h2 class="subtitle-1">Need some help? You found a bug? Contact me via:</h2>
                </div>
              </div>
              <div class="row mb-5">
                <div class="col-md-12 text-center mb-4">
                  <img src="@/assets/img/onboardings/bug-fix.svg" class="img-fluid" width="300px" height="300px"
                       alt="Bug fix image">
                </div>
                <div class="col-md-12 text-center">
                  <a href="mailto:colorffy@gmail.com" title="Colorffy support email"
                     class="btn btn-primary-light btn-micint-x btn-xs-full-width ripple ripple-dark py-3 px-5">Email
                    <i class="material-icons-outlined">arrow_forward</i>
                  </a>

                  <a href="https://mobile.twitter.com/giangzadev" title="Gian Twitter" target="_blank" rel="noopener"
                     class="btn btn-primary-light btn-micint-x btn-xs-full-width ripple ripple-dark py-3 px-5">
                    Twitter DM
                    <i class="material-icons-outlined">arrow_forward</i>
                  </a>

                  <a href="https://colorffy.the-docs.com/docs/latest/support/help-guide" title="User Guides"
                     target="_blank" rel="noopener"
                     class="btn btn-primary-light btn-micint-x btn-xs-full-width ripple ripple-dark py-3 px-5">
                    User guides
                    <i class="material-icons-outlined">arrow_forward</i>
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- SUPPORT ME -->
      <SupportMe></SupportMe>

    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/components/includes/Footer";
import Navbar from "@/components/includes/Navbar";
import {mapGetters} from 'vuex'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import SupportMe from "@/components/cta/SupportMe";

export default {
  name: 'Profile',
  metaInfo() {
    return {
      title: this.user.data.displayName || 'Loading...',
    }
  },
  components: {SupportMe, Navbar, Footer},
  computed: {
    ...mapGetters(['user'])
  },
  mounted() {
    this.getProvider()
  },
  methods: {
    getProvider() {
      return firebase.auth().currentUser.providerData[0].providerId
    },
    onDeleteAccount() {
      const user = firebase.auth().currentUser

      user.delete()
      this.$swal({
        customClass: {
          confirmButton: 'btn btn-primary btn-w-100',
        },
        buttonsStyling: false,
        showConfirmButton: true,
        icon: 'warning',
        title: 'Account deleted',
        text: 'Goodbye!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$router.replace("/")
        }
      }).catch(err => {
        this.error = err.message
      })
    }
  }
}
</script>